import * as React from "react";
function SvgUserArrowDownLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M3 25l4 4 4-4M7 19v8"
      />
      <circle
        cx={18}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M22.89 29H29a11 11 0 00-18.54-8"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserArrowDownLeft);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
